class BuyingJourney extends HTMLElement {
  constructor() {
    super();
    this.currentTab = 0; // Current tab is set to be the first tab (0)
    let nextTab = 1;
    let prevTab = -1;
    this.allowloading = true;
    this.prevStepButton = document.getElementById("prevStepBtn");
    this.nextStepButton = document.getElementById("nextStepBtn");
    this.buyingSteps = this.querySelectorAll(".step-container");
    this.dialogueBox = document.querySelector(".configuration-box-wrapper");
    this.emailVerified = false;
    this.editOrder = false;
    // Add debounce timer for removeQuoteProduct
    this.removeQuoteProductDebounceTimer = null;
    const parent = this;
    this.prevStepButton.addEventListener("click", function () {
      parent.switchStep(prevTab, "prev");
      parent.allowloading = false;
    });
    this.nextStepButton.addEventListener("click", function () {
      parent.switchStep(nextTab, "next");
      parent.allowloading = true;
    });

    this.TokenUtils = {
      encode(obj) {
        const json = JSON.stringify(obj);
        // Compress to Uint8Array
        const compressed = pako.deflate(json);
        // Convert bytes to base64
        const base64 = btoa(String.fromCharCode.apply(null, compressed));
        // Make URL-safe
        return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      },

      decode(token) {
        // Restore base64
        let base64 = token.replace(/-/g, '+').replace(/_/g, '/');
        // Decode base64 to binary string
        const binary = atob(base64);
        // Convert to Uint8Array
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i);
        }
        // Decompress
        const json = pako.inflate(bytes, { to: 'string' });
        return JSON.parse(json);
      },
    };
    // live
    this.buyingJourneyApi = 'https://buying-journey--slide-and-fold-d215c3c042c7.herokuapp.com/api';

    this.buyingJourneyProducts = [];
    this.originalBuyingJourneyProducts = [];
    this.setDisableNextButton(); // Initially disable the next button

    this.lastCartBottom = document.querySelectorAll(".bj-cart-bottom");
    this.selectedTemplate = "";

    this.changeEvent = new Event("change", {
      bubbles: true,
      cancelable: true,
    });

    this.configurationPopup = document.querySelector("configuration-popup");
    this.createQuoteFlag = false;
    this.aluminiumDoor = new window.AluminiumBifoldDoor();
    this.slidingDoor = new window.SlidingDoor();
    this.garageDoor = new window.GarageDoor();
    this.windowsPanels = new window.WindowsPanel();
    this.internalDoor = null;
    this.verifyEmailBtn = this.querySelector("#verifiy-email-label");

    if (this.verifyEmailBtn) {
      this.verifyEmailBtn.addEventListener(
        "click",
        this.verifyEmail.bind(this)
      );
    }

    this.verifyEmailWrapper = this.querySelector(".verify-email");
    this.verifyEmailPopup = document.querySelector(".email-verification-popup");

    document
      .querySelector(".complete-confirm")
      .addEventListener("click", () => {
        this.verifyEmailPopup.style.display = "none";
        this.verifyEmailStatus();
      });
    this.getPersonDetails();
  }

  connectedCallback() {
    this.render();
    this.doStepCalculations();
  }

  render() {
    const { lastCartBottom, nextStepButton, prevStepButton } = this;

    if (lastCartBottom.length > 1) {
      lastCartBottom[lastCartBottom.length - 1].style.borderBottom =
        "1px solid darkgray";
    }

    if (nextStepButton) {
      nextStepButton.addEventListener(
        "click",
        this.doStepCalculations.bind(this)
      );
    }

    switch (this.dataset.template) {
      case "aluminium-doors":
        this.selectedTemplate = this.aluminiumDoor;
        break;
      case "sliding-doors":
        this.selectedTemplate = this.slidingDoor;
        break;
      case "garage-doors":
        console.log(this.garageDoor);
        this.selectedTemplate = this.garageDoor;
        break;
      case "windows":
        console.log(this.windowsPanels);
        this.selectedTemplate = this.windowsPanels;
        break;
      case "internal-doors":
        console.log(this.internalDoor);
        this.selectedTemplate = this.internalDoor;
        break;
      default:
        break;
    }

    if (prevStepButton) {
      prevStepButton.addEventListener(
        "click",
        this.doStepCalculations.bind(this)
      );
    }

    this.initializeFooterSteps(); // Initialize the footer steps
    this.setActiveStepOnUrlParam();
  }

  initializeFooterSteps() {
    const allSteps = this.buyingSteps;
    let stepsWrapper = this.querySelector(".footer-steps");
    let prevStepName = "";
    allSteps.forEach((step, index) => {
      const currentStepName = step.dataset.stepName;
      if (currentStepName != prevStepName) {
        const newStep = `
         <div class="step" data-step-For="${currentStepName}">
            <div class="step-info">
              <span class="step-icon">
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 5.30769L3.77778 8L11 1" stroke="#2E2E2E"/>
                </svg>
              </span>
              <span class="step-text">
                ${currentStepName}
              </span>
            </div>
          </div>  
        `;
        stepsWrapper.innerHTML += newStep;
      }
      prevStepName = currentStepName;
    });
  }

  handleStepProgress() {
    const currentActiveTab = this.querySelector(".step-container.active")
      .dataset.stepName;
    const previouslyActiveStep = this.querySelector(".step.active");
    const childActiveSteps = this.querySelectorAll(
      '.step-container[data-step-name="' + currentActiveTab + '"]'
    );
    const activeStep = this.querySelector(
      '.step[data-step-for="' + currentActiveTab + '"]'
    );
    const completedChildSteps = Array.from(childActiveSteps).filter((step) =>
      step.classList.contains("completed")
    );
    const progress_width =
      33.33 + (completedChildSteps.length / childActiveSteps.length) * 100;
    if (childActiveSteps.length > 1) {
      if (activeStep.querySelector(".progress-step")) {
        activeStep.querySelector(".progress-step").style.width =
          progress_width + "%";
      } else {
        const progressBar = `
      <div class="progress-container">
        <div class="progress-step" style="width:${progress_width}%;">
        </div>
      </div>
      `;
        activeStep.innerHTML += progressBar;
      }
    }
    if (previouslyActiveStep) {
      previouslyActiveStep.classList.remove("active"); // remove the active class from previously active step
    }
    activeStep.classList.add("active");
  }

  showSwitchedTab(n) {
    const steps = this.buyingSteps;
    const step = steps[n];
    if (!step) {
      return;
    }
    step.classList.add("active");
    this.prevStepButton.classList.toggle("disabled", n === 0);

    if (steps.length - 2 === n) {
      this.nextStepButton.querySelector("span").textContent = "View Quote";
    } else if (steps.length - 1 === n) {
      this.nextStepButton.classList.add("hidden");
      this.querySelector("#submit").style.display = "flex";
    } else if (n === this.finishStepAt) {
      this.nextStepButton.querySelector("span").textContent = "Update";
    } else {
      this.nextStepButton.classList.remove("hidden");
      this.querySelector("#submit").style.display = "none";
      this.nextStepButton.querySelector("span").textContent = "Next";
    }

    this.handleStepProgress(); // update the progress bar according to completed steps.
  }

  /*
   * @param {number} n - The number of steps to skip
   * @description Skips the next n steps and adds them to the skipped steps set
   */
  skipNextNSteps(n, triggerStepNumber = null) {
    this.skippedSteps = this.skippedSteps || new Set();
    const currentStep = triggerStepNumber || this.currentTab;
    for (let i = 1; i <= n; i++) {
      this.skippedSteps.add(currentStep + i);
    }

    console.log("skippedSteps", this.skippedSteps);
  }

  /*
   * @param {number} n - The number of steps to unskip
   * @description Removes the next n steps from the skipped steps set
   */
  unskipNextNSteps(n, triggerStepNumber = null) {
    this.skippedSteps = this.skippedSteps || new Set();
    const currentStep = triggerStepNumber || this.currentTab;
    for (let i = 1; i <= n; i++) {
      this.skippedSteps.delete(currentStep + i);
    }
  }

  switchStep(n, direction = "next") {
    const currentStep = this.buyingSteps[this.currentTab];
    if (this.currentTab === this.finishStepAt && n > 0) {
      this.doStepCalculations(this.currentTab + 1);
      this.updateProduct();
      return;
    }
    if (!currentStep) {
      return;
    }
    currentStep.classList.remove("active");
    this.buyingSteps.forEach((step, index) => {
      if (index <= this.currentTab + n) {
        step.classList.remove("active");
      }
    });
    if (n > 0) {
      currentStep.classList.add("completed");
      n += parseInt(this.nextStepButton.dataset.increment);
    } else {
      currentStep.classList.remove("completed");
      n -= parseInt(this.prevStepButton.dataset.decrement);
    }

    this.currentTab += n;

    // Skip over any steps in the skippedSteps set based on direction
    if (this.skippedSteps && this.skippedSteps.size > 0) {
      const maxIterations = this.buyingSteps.length; // Prevent infinite loops
      let iterations = 0;

      while (
        this.skippedSteps.has(this.currentTab) &&
        iterations < maxIterations
      ) {
        if (direction === "next") {
          this.currentTab++;
        } else if (direction === "prev") {
          this.currentTab--;
        } else {
          break; // No direction specified, stop skipping
        }
        iterations++;
      }
    }

    this.showSwitchedTab(this.currentTab);
  }

  async updateProduct() {
    const product = this.selectedTemplate.collectProductData();
    const draftOrderId = this.draftOrderId.replace(
      "gid://shopify/DraftOrder/",
      ""
    );
    const res = await fetch(
      `${this.buyingJourneyApi}/update-draft-order/${draftOrderId}`,
      {
        method: "PUT",
        body: JSON.stringify({
          productUpdates: product,
          productId: this.selectedTemplate.buyingJourneyObject.product_id,
          variantId: this.selectedTemplate.buyingJourneyObject.id,
        }),
        headers: { "Content-Type": "application/json" },
      }
    );
    if (res.ok) {
      // remove the modified product from local storage
      window.localStorage.removeItem("modified-product");
      window.location.href = `${window.location.origin}/${window.location.pathname}?step=overview&orderId=${draftOrderId}`;
    } else {
      console.log("Product not updated");
    }
  }

  setActiveNextButton() {
    this.nextStepButton.classList.remove("disabled");
    this.nextStepButton.disabled = false;
  }

  setDisableNextButton() {
    this.nextStepButton.classList.add("disabled");
    this.nextStepButton.disabled = true;
  }

  doStepCalculations(customStep) {
    window.scrollTo(0, 130);
    const tab = typeof customStep === "number" ? customStep : this.currentTab;
    const action = this.selectedTemplate.stepActions[tab];
    if (typeof action === "function") {
      action();
    } else {
      console.log("Not of function type");
    }
  }

  setActiveStepOnUrlParam() {
    // Get the full query string from the URL
    const queryString = window.location.search;
    // Create a URLSearchParams object from the query string
    const urlParams = new URLSearchParams(queryString);

    // Get the value of the "step" parameter
    let stepNo = 1;
    if (urlParams.get("step") == "overview") {
      stepNo = Object.keys(this.selectedTemplate.stepActions).length - 1;
    } else {
      stepNo = parseInt(urlParams.get("step") - 1);
    }
    if (stepNo > 0) {
      this.switchStep(stepNo);
    } else {
      this.showSwitchedTab(this.currentTab); // Displays the first tab on page load
    }

    if (
      urlParams.get("edit-order") == "true" &&
      window.localStorage.getItem("modified-product")
    ) {
      const modifiedProduct = JSON.parse(
        window.localStorage.getItem("modified-product")
      );
      this.selectedTemplate.buyingJourneyObject =
        modifiedProduct.object._buyingJourneyObject;
      this.draftOrderId = modifiedProduct.draftOrderId;
      this.editOrder = true;
      this.selectedTemplate.preselectOptions &&
        this.selectedTemplate.preselectOptions();
      this.finishStepAt = this.selectedTemplate.finishStepAt;
    }
  }

  validateEmail() {
    // Retrieve the email input element by its ID
    const emailElement = document.getElementById("quote-email");
    // Get the current value of the input field
    const emailValue = emailElement.value;
    // Define a regular expression for email validation
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    // Test the email value against the regular expression
    if (!regex.test(emailValue)) {
      // If the email does not match the pattern, add 'invalid' class
      emailElement.classList.add("invalid");
      this.verifyEmailWrapper.classList.add("hidden");
      return false; // Return false indicating validation failed
    } else {
      // If the email matches the pattern, remove 'invalid' class if it exists
      emailElement.classList.remove("invalid");
      // this.verifyEmailWrapper.classList.remove("hidden");
      // this.verifyEmailStatus(emailValue);
      return true; // Return true indicating validation succeeded
    }
  }

  validateAndFormatPhone(userInput, defaultCountry = "GB") {
    // This function returns a parsed phone number if valid
    const phoneNumber = libphonenumber.parsePhoneNumberFromString(
      userInput,
      defaultCountry
    );
    if (phoneNumber && phoneNumber.isValid()) {
      // Format to E.164 (e.g., +442079460321)
      return { valid: true, phone: phoneNumber.format("E.164") };
    } else {
      return { valid: false, error: "Invalid phone number format." };
    }
  }

  //build the cart page from here, start helping functions for cart page.
  // Main entry point for quote overview

  async readyQuoteOverview() {
    console.log("Ready Quote Overview");

    const { buyingJourneyApi, buyingJourneyProducts } = this;

    try {
      var currentUrlParams = new URLSearchParams(window.location.search);
      const orderId = currentUrlParams.get("orderId");

      if (orderId) {
        try {
          //Clear the existing products from the cart before displaying order products.
          const clearRes = await fetch("/cart/clear.js", {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
          });
          await clearRes.json();

          // 2. Fetch the draft order
          const draftRes = await fetch(
            `${buyingJourneyApi}/get-draft-order?id=${orderId}`
          );
          const draftJson = await draftRes.json();
          const items = draftJson?.draftOrder?.lineItems?.nodes;
          this.draftOrderId = draftJson?.draftOrder?.id;

          // 3. Add each item back into the cart, waiting for each add to complete
          for (const item of items) {
            const propertiesObject = item.customAttributes.reduce(
              (acc, { key, value }) => {
                acc[key] = value;
                return acc;
              },
              {}
            );
            await this.addProductInCart(item.variant.id, propertiesObject);
          }
        } catch (err) {
          console.error("Error syncing cart from draft order:", err);
          throw err; // or handle it gracefully
        }
        this.prevStepButton.disabled = true;
        this.prevStepButton.classList.add("disabled");
      } else {
        if (this.createQuoteFlag) {
          await this.createBuyingJourneyProduct();
          this.prevStepButton.disabled = false;
          this.prevStepButton.classList.remove("disabled");
        }
      }

      const cart = await this.fetchCartItems();

      //empty the array before inserting new products
      buyingJourneyProducts.length = 0;
      const quoteItems = this.getQuoteItems(cart.items);

      quoteItems.forEach((quoteItem) => {
        let productObject;
        switch (quoteItem.properties["Product type"]) {
          case "aluminium_doors":
            productObject =
              this.aluminiumDoor.convertOrderItemsIntoProductObject(quoteItem);
            break;
          case "sliding_doors":
            console.log("Sliding Door quote item");
            productObject =
              this.slidingDoor.convertOrderItemsIntoProductObject(quoteItem);
            break;
          case "garage_doors":
            console.log("Garage Door quote item");
            productObject =
              this.garageDoor.convertOrderItemsIntoProductObject(quoteItem);
            break;
          case "windows":
            console.log("Windows quote item");
            productObject =
              this.windowsPanels.convertOrderItemsIntoProductObject(quoteItem);
            break;
          case "internal-doors":
            console.log("Internal Door quote item");
            productObject =
              this.internalDoor.convertOrderItemsIntoProductObject(quoteItem);
            break;
          default:
            break;
        }
        if (productObject) {
          buyingJourneyProducts.push({ ...productObject });
        }
      });

      if (!buyingJourneyProducts.length && !quoteItems.length) {
        this.showEmptyCart();
        return;
      }
      this.originalBuyingJourneyProducts = JSON.parse(
        JSON.stringify(buyingJourneyProducts)
      );
      this.renderQuoteItems(buyingJourneyProducts);
      this.updateTotals(buyingJourneyProducts);
      await this.initializeCheckoutFlow(quoteItems);
      this.attachGeneratePdfHandlers();
    } catch (error) {
      console.error("Error in readyQuoteOverview:", error);
      this.displayError(
        "There was a problem loading the quote overview. Please try again later."
      );
    }
  }

  // Fetch cart data with error handling
  async fetchCartItems() {
    return await fetch("/cart.js", {
      credentials: "same-origin",
    }).then((r) => r.json());
  }

  // Filter out only quote-related items
  getQuoteItems(items = []) {
    return items.filter((item) => item.product_type === "quote-product");
  }

  //Overview page work

  // Render quote items into the DOM
  renderQuoteItems(items) {
    console.log("Render quote items");

    const wrapper = document.querySelector(".bj-cart-items-wrapper");
    if (!wrapper) throw new Error("Cart items wrapper not found");

    wrapper.innerHTML = ""; // clear existing
    const fragment = document.createDocumentFragment();

    items.forEach((item) => {
      let elementToInsert;
      switch (item.productType) {
        case "aluminium_doors":
          console.log("Aluminium Door element");
          elementToInsert = this.aluminiumDoor.createQuoteItemElement(item);
          break;
        case "sliding_doors":
          console.log("Sliding Door element");
          elementToInsert = this.slidingDoor.createQuoteItemElement(item);
          break;
        case "garage_doors":
          console.log("Garage Door element");
          elementToInsert = this.garageDoor.createQuoteItemElement(item);
          break;
        case "windows":
          console.log("Windows element");
          elementToInsert = this.windowsPanels.createQuoteItemElement(item);
          break;
        case "internal-doors":
          console.log("Internal Door element");
          elementToInsert = this.selectedTemplate.createQuoteItemElement(item);
          break;
        default:
          break;
      }
      if (elementToInsert) {
        fragment.appendChild(elementToInsert);
      }
    });

    wrapper.appendChild(fragment);

    this.attachOverviewPageEventListeners();
  }

  // Create individual quote item element
  createQuoteItemElement(item) {
    const { buyingJourney } = this;

    // Safely extract all needed values with defaults
    const title = item?.title ?? "";
    const totalPrice = item?.totalPrice ?? 0;
    const panelImage = item?.panelSize?.panelImage ?? "";
    const panelWidth = item?.panelInfo?.panelWidth ?? "";
    const panelHeight = item?.panelInfo?.panelHeight ?? "";
    const stackingDirection = item?.panelSize?.stackingDirection ?? "";
    const outsideColour = item?.panelOutsideColour?.value ?? "";
    const accessOrderNote = item?.accessIssue?.orderNote;
    const accessIssueText =
      !accessOrderNote || accessOrderNote === "null" ? "No" : accessOrderNote;
    const orientation = item?.panelInfo?.orientation ?? "";
    const topAddon = item?.profileAddons?.top ?? "";
    const leftAddon = item?.profileAddons?.left ?? "";
    const rightAddon = item?.profileAddons?.right ?? "";
    const handleColour = item?.panelHandle?.value ?? "";
    const trickleVents = item?.trickleVents?.value ?? "";
    const hingeColour = "Black"; // constant in original
    const barsDirection = item?.barsfitting?.direction;
    const horizBars = barsDirection === "Horizontal" ? barsDirection : "No";
    const vertBars = barsDirection === "Vertical" ? barsDirection : "No";
    const panelsValue = item?.panelSize?.value ?? "";
    const insideColour = item?.panelInsideColour?.value ?? "";
    const glass = item?.panelGlass?.value ?? "";
    const cillValue = item?.cill?.value;
    const cill = !cillValue || cillValue === "null" ? "No" : cillValue;
    const blindsValue = item?.blinds?.value;
    const blinds = !blindsValue || blindsValue === "null" ? "No" : blindsValue;
    const threshold = item?.threshold?.value ?? "";
    const delivery = "Standard"; // constant in original

    const div = document.createElement("div");
    div.className = "bj-cart-bottom";
    div.innerHTML = `
    <div class="bj-cart-bottom-right-top accordion-toggle">
      <div class="cart-accor-header-left">
        <h2 class="bj-cart-heading accordion-toggle">${title}</h2>
        <div class="bj-cart-total-price">
          <span class="bj-cart-price" data-price="${totalPrice}" data-order-price>${Shopify.formatMoney(
      totalPrice
    )}</span>
          <span class="bj-cart-price-text">+ VAT</span>
        </div>
      </div>
      <div class="cart-accor-header-left">
        <button type="button" class="accordion-toggle">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
              <rect y="0.224609" width="28" height="28" rx="14" fill="#967b50"></rect>
              <path d="M7.51465 15.8193L13.9999 9.33398L20.4852 15.8193" stroke="#f1f1f1" stroke-width="1.64706" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </button>
      </div>
    </div>
    <div class="bj-cart-bottom-in">
      <div class="bj-cart-bottom-in-left">
        <div class="cart-item-image">
          <img id="order-featured-image" src="${panelImage}" alt="${title}" class="bj-cart-image" />
        </div>
      </div>
      <div class="bj-cart-bottom-in-right">
        <div class="bj-cart-bottom-right-center">
          <h3 class="bj-cart-detail-heading">Your door</h3>
          <div class="bj-cart-details">
            ${this.renderDetail(
      "Manufacturing size (mm)",
      `${panelWidth} x ${panelHeight}`,
      "1",
      "1"
    )}
            ${this.renderDetail(
      "Stacking direction",
      stackingDirection,
      "2",
      "0"
    )}
            ${this.renderDetail("Outside colour", outsideColour, "4", "0")}
            ${this.renderDetail("Access issues", accessIssueText, "17", "0")}
            ${this.renderDetail("Opening directions", orientation, "3", "0")}
            ${this.renderDetail("Top addon", topAddon, "13", "0")}
            ${this.renderDetail("Handle colour", handleColour, "6", "0")}
            ${this.renderDetail("Left addon", leftAddon, "13", "0")}
            ${this.renderDetail("Trickle vents", trickleVents, "12", "0")}
            ${this.renderDetail("Hinge colour", hingeColour, "", "0")}
            ${this.renderDetail(
      "Horizontal Astragal bars",
      horizBars,
      "9",
      "2"
    )}
            ${this.renderDetail("Right addon", rightAddon, "13", "0")}
            ${this.renderDetail("Panels", panelsValue, "2", "0")}
            ${this.renderDetail("Inside colour", insideColour, "5", "0")}
            ${this.renderDetail("Vertical Astragal bars", vertBars, "9", "2")}
            ${this.renderDetail("RAL colour", outsideColour, "4", "0")}
            ${this.renderDetail("Glass", glass, "7", "0")}
            ${this.renderDetail("Cill", cill, "15", "0")}
            ${this.renderDetail("Blinds", blinds, "8", "0")}
            ${this.renderDetail("Threshold", threshold, "14", "0")}
            ${this.renderDetail("Delivery", delivery, "", "0")}
          </div>
            <div class="product-cta">
              <a class="bj-cart-image-text removeQuoteProduct" data-item-id="${item?.id ?? ""
      }" data-product-id="${item?.product_id ?? ""}">
                <span>Remove</span>
                 <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <rect x="21.8047" y="0.199219" width="21.601" height="21.601" rx="10.8005" transform="rotate(90 21.8047 0.199219)" fill="#967b50"/>
                  <path d="M8.45014 7.98345L14.0186 7.98345L14.0186 13.5519M13.6319 8.37015L7.9861 14.016" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </a>
            </div>
        </div>
      </div>
    </div>
  `;

    // Attach remove handler
    div
      .querySelector(".removeQuoteProduct")
      ?.addEventListener("click", () =>
        this.removeQuoteProduct(item.id, item.product_id)
      );

    // Attach edit handlers (if any)
    div.querySelectorAll(".edit-option")?.forEach((option) =>
      option.addEventListener("click", () => {
        this.editHandler(option, item);
      })
    );

    return div;
  }

  editHandler(input, object) {
    const draftOrderId = this.buyingJourney.draftOrderId;
    const stepIndex = input.dataset.stepCount;
    // write an object to the localestoarge
    const editObject = {
      object,
      draftOrderId,
    };
    localStorage.setItem("modified-product", JSON.stringify(editObject));
    //const currentPath = window.location.pathname;
    window.location.href = `/pages/bifold-door-builder?step=${stepIndex}&edit-order=true`;
  }

  // Helper to render individual detail lines
  renderDetail(label, value, id, stepCount) {
    return `
    <div class="bj-cart-details-in">
      <p class="bj-cart-details-text">
        ${label}
       ${id == ""
        ? ``
        : `<span
          class="edit-option"
          data-dialog-id="${id}"
          data-step-count="${stepCount}"
        >
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 30 30">
            <path d="M 22.828125 3 C 22.316375 3 21.804562 3.1954375 21.414062 3.5859375 L 19 6 L 24 11 L 26.414062 8.5859375 C 27.195062 7.8049375 27.195062 6.5388125 26.414062 5.7578125 L 24.242188 3.5859375 C 23.851688 3.1954375 23.339875 3 22.828125 3 z M 17 8 L 5.2597656 19.740234 C 5.2597656 19.740234 6.1775313 19.658 6.5195312 20 C 6.8615312 20.342 6.58 22.58 7 23 C 7.42 23.42 9.6438906 23.124359 9.9628906 23.443359 C 10.281891 23.762359 10.259766 24.740234 10.259766 24.740234 L 22 13 L 17 8 z M 4 23 L 3.0566406 25.671875 A 1 1 0 0 0 3 26 A 1 1 0 0 0 4 27 A 1 1 0 0 0 4.328125 26.943359 A 1 1 0 0 0 4.3378906 26.939453 L 4.3632812 26.931641 A 1 1 0 0 0 4.3691406 26.927734 L 7 26 L 5.5 24.5 L 4 23 z"></path>
          </svg>
        </span>`
      }
      </p>
      <p
        class="bj-cart-details-value"
      >
        ${value || "N/A"}
      </p>
    </div>
  `;
  }

  // Update total price and UI
  updateTotals(items) {
    const totalPrice = items.reduce((sum, i) => sum + i.totalPrice, 0);
    const priceEl = this.querySelector(".bj-cart-total-price .bj-cart-price");
    if (priceEl) {
      priceEl.textContent = Shopify.formatMoney(totalPrice);
      priceEl.setAttribute("data-total-price", totalPrice);
    }
    this.setActiveNextButton();
  }

  // Checkout initialization: disable, then enable when ready
  async initializeCheckoutFlow(quoteItems) {
    this.prevStepButton.disabled = true;
    this.prevStepButton.classList.add("disabled");
    this.enableCheckoutButton();
    if (!this.createQuoteFlag) return;

    try {
      const bj = this.selectedTemplate.buyingJourneyObject;
      const person = {
        firstName: bj.gtAccessQoute.firstName,
        lastName: bj.gtAccessQoute.lastName,
        email: bj.gtAccessQoute.email || this.personDetails.email,
        phone: bj.gtAccessQoute.mobile || this.personDetails.phone,
        postCode: bj.postCode.value,
      };
      await this.createDraftOrder(quoteItems, person);
    } catch (err) {
      console.error("Error in checkout flow:", err);
      this.displayError("An error occurred during checkout.");
    }
  }

  getProductType(productType) {
    switch (productType) {
      case "aluminium_doors":
        return this.aluminiumDoor;
        break;
      case "garage_doors":
        return this.garageDoor;
        break;
      case "sliding_doors":
        return this.aluminiumDoor;
        break;
      case "windows":
        return this.windowsPanels;
        break;
      default:
        break;
    }
  }

  generateRandomSixDigitNumber() {
    return Math.floor(100000 + Math.random() * 900000);
  }
  // Display a user-friendly error message
  displayError(message) {
    // Implement UI feedback, e.g., toast or modal
    alert(message);
  }

  // Attach PDF generation handlers
  attachGeneratePdfHandlers() {
    document.querySelectorAll(".bj-cart-quote-button").forEach((button) => {
      button.addEventListener("click", () => {
        this.generatePDF();
      });
    });
  }
  showEmptyCart() {
    const submitButton = this.querySelector("#submit"); // update the submit button link and text
    this.querySelector(
      ".bj-cart-items-wrapper"
    ).innerHTML = `<p class="no-items">There is no quote product in the cart.</p>`;
    this.querySelectorAll(".bj-cart-quote-button").forEach(
      (quoteDownloadButton) => (quoteDownloadButton.disabled = true)
    );
    submitButton.innerHTML = "Back to Buying Journey";
    submitButton.classList.remove("loading");
    submitButton.href = "/pages/bifold-door-builder";
  }

  // Helper function to wait for all images in a container to load
  waitForImagesToLoad(container) {
    return new Promise((resolve) => {
      const images = container.querySelectorAll("img");
      if (images.length === 0) {
        resolve();
        return;
      }

      let loadedCount = 0;
      const totalImages = images.length;

      const checkAllLoaded = () => {
        loadedCount++;
        if (loadedCount === totalImages) {
          resolve();
        }
      };

      images.forEach((img) => {
        if (img.complete && img.naturalHeight !== 0) {
          checkAllLoaded();
        } else {
          img.addEventListener("load", checkAllLoaded);
          img.addEventListener("error", checkAllLoaded); // Handle broken images
        }
      });
    });
  }

  async attachOverviewPageEventListeners() {
    var acc = document.getElementsByClassName("accordion-toggle");
    var i;

    // Function to set panel max-height after images are loaded
    const setPanelMaxHeight = async (panel) => {
      await this.waitForImagesToLoad(panel);
      panel.style.maxHeight = panel.scrollHeight + "px";
    };

    if (acc.length > 0) {
      acc[0].classList.add("active"); // Add the "active" class to the first accordion button
      var firstPanel = acc[0].nextElementSibling;
      await setPanelMaxHeight(firstPanel); // Open the first panel after images load
    }

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", async function () {
        var panel = this.nextElementSibling;
        const button = this.querySelector("button.accordion-toggle");
        button.classList.toggle("active");
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          // Wait for images to load before setting max-height
          await new Promise((resolve) => {
            const images = panel.querySelectorAll("img");
            if (images.length === 0) {
              resolve();
              return;
            }

            let loadedCount = 0;
            const totalImages = images.length;

            const checkAllLoaded = () => {
              loadedCount++;
              if (loadedCount === totalImages) {
                resolve();
              }
            };

            images.forEach((img) => {
              if (img.complete && img.naturalHeight !== 0) {
                checkAllLoaded();
              } else {
                img.addEventListener("load", checkAllLoaded);
                img.addEventListener("error", checkAllLoaded); // Handle broken images
              }
            });
          });
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }

    const removeQuoteButtons = this.querySelectorAll(".removeQuoteProduct");

    removeQuoteButtons.forEach((button) => {
      button.addEventListener("click", async (event) => {
        if (button.dataset.itemId) {
          event.preventDefault(); // stop any default link/form behavior
          try {
            await this.removeQuoteProduct(
              button.dataset.itemId,
              button.dataset.productId
            ); // remove from cart
            // console.log('Product removed from cart');
            // after a short pause, redirect back to step 1
            // setTimeout(() => {
            //   window.location.href = '/pages/bifold-door-builder?step=1';
            // }, 1500);
          } catch (err) {
            console.error("Failed to remove product:", err);
            // optionally show a user‐facing error message here
          }
        }
      });
    });
  }
  async createBuyingJourneyProduct() {
    const classInstance = this;
    const { buyingJourneyObject } = this.selectedTemplate;
    if (buyingJourneyObject.panelInfo.panelWidth == null) {
      console.warn("Fill the product info before going to overview page");
      return;
    }

    const noProductsAddon = this.querySelector("#no-thanks");

    if (!noProductsAddon || noProductsAddon.checked) {
      this.setActiveNextButton();
    } else {
      this.setDisableNextButton();
    }

    noProductsAddon.addEventListener("change", function () {
      if (this.checked) {
        classInstance.setActiveNextButton();
      }
    });

    try {
      // Create a product by calling the API
      const response = await fetch(`${this.buyingJourneyApi}/create-product`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.selectedTemplate.collectProductData()),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData);
      }

      const data = await response.json();
      console.log("Product Data", data);
      console.log("Product created successfully");

      // Wait for addProductInCart to finish
      const variantId = data.product.variants.nodes[0].id;
      await this.addProductInCart(
        variantId,
        this.selectedTemplate.getProductProperties()
      );
    } catch (error) {
      console.error("Error creating product:", error.message);
    }
  }

  async addProductInCart(variantId, productProperties, retryCount = 0) {
    const MAX_RETRIES = 3;
    try {
      let formatedVariantId = variantId.replace(
        "gid://shopify/ProductVariant/",
        ""
      );
      //  Add the new item to the cart
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: formatedVariantId,
              quantity: 1,
              properties: productProperties,
            },
          ],
        }),
      });

      const addResult = await addResponse.json();
      if (!addResponse.ok) {
        console.error("Failed to add new item to cart:", addResult);
        if (retryCount < MAX_RETRIES) {
          console.log(`Retrying add to cart (${retryCount + 1}/${MAX_RETRIES}) in 3s...`);
          await new Promise((resolve) => setTimeout(resolve, 3000));
          return this.addProductInCart(variantId, productProperties, retryCount + 1);
        }
        return;
      }
      console.log("New item added to cart successfully:", addResult.items);

      return addResult;
    } catch (error) {
      console.error("An error occurred while updating the cart:", error);
      if (retryCount < MAX_RETRIES) {
        console.log(`Retrying add to cart (${retryCount + 1}/${MAX_RETRIES}) in 3s...`);
        await new Promise((resolve) => setTimeout(resolve, 3000));
        return this.addProductInCart(variantId, productProperties, retryCount + 1);
      }
    }
  }

  enableCheckoutButton() {
    const checkoutBtn = document.querySelector("a#submit");
    checkoutBtn.classList.remove("loading");
    checkoutBtn.classList.remove("disabled");
    if (checkoutBtn.querySelector(".loading__spinner"))
      checkoutBtn.querySelector(".loading__spinner").classList.add("hidden");
  }

  async removeProductFromCart(lineItemKey) {
    if (lineItemKey) {
      // Step 3: Delete the existing item from the cart
      const deleteResponse = await fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: 0, // Set quantity to 0 to remove the item
        }),
      });

      const deleteResult = await deleteResponse.json();

      if (!deleteResponse.ok) {
        console.error("Failed to remove existing cart item:", deleteResult);
        // reload the page
        if (window.location.search.includes("step=overview")) {
          window.location.reload();
        } else {
          const draftOrderId = this.draftOrderId.replace(
            "gid://shopify/DraftOrder/",
            ""
          );
          window.location.href = `/${window.location.pathname}?step=overview&orderId=${draftOrderId}`;
        }
        return;
      }
      return deleteResult;
    }
  }

  async createDraftOrder(cartItems, person, isRetry = false) {
    const { buyingJourneyObject } = this.selectedTemplate;
    const lineItems = cartItems
      .filter((item) => item.product_type === "quote-product")
      .map((item) => ({
        variant_id: item.variant_id,
        quantity: item.quantity,
        properties: Object.entries(item.properties).map(([name, value]) => ({
          name,
          value,
        })),
      }));

    try {
      const response = await fetch(`${this.buyingJourneyApi}/create-draft-order`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ person, lineItems }),
      });

      if (!response.ok) {
        if (!isRetry) {
          return await this.createDraftOrder(cartItems, person, true);
        }
        this.displayError("Could not create your quote. Please try again.");
        return;
      }

      const data = await response.json();
      buyingJourneyObject.invoiceUrl = data.invoiceUrl;
      this.draftOrderId = data.id;
      console.log("Draft Order Created:", data.id);

      await this.sendQuoteEmail(data.id);
    } catch (error) {
      if (!isRetry) {
        return await this.createDraftOrder(cartItems, person, true);
      }
      console.error("Error creating draft order:", error.message);
      this.displayError("Could not create your quote. Please try again.");
    }
  }

  handleAddMoreProducts() {
    this.setDisableNextButton();

    this.querySelectorAll(".add-product-label").forEach((input) =>
      input.addEventListener("click", async () => {
        if (input.dataset.url && input.dataset.url != "#") {
          document.querySelector(
            ".adding-to-cart-loading-wraper"
          ).style.display = "block";
          this.createQuoteFlag = true;
          await this.readyQuoteOverview();
          console.log("Product Added to cart, Ready to switch to new page");
          document.querySelector(
            ".adding-to-cart-loading-wraper"
          ).style.display = "none";
          window.location.href = input.dataset.url;
        }

        if (input.value == "nothanks") {
          this.createQuoteFlag = true; //set the quote flag to true to generate the quote
          this.nextStepButton.disabled = false;
          this.nextStepButton.classList.remove("disabled");
        }
      })
    );

    const noThanksLabel = this.querySelector("#no-thanks");

    if (!noThanksLabel || noThanksLabel.checked) {
      this.setActiveNextButton();
    }
  }

  generatePDF = async function generatePDF(evt) {
    if (evt?.preventDefault) evt.preventDefault();
    if (evt?.stopPropagation) evt.stopPropagation();
    try {
      // Optimize the content fetching process
      window.pdfContent__ = await getDocumentFormatOfProduct();

      // Check if content exists and is valid
      if (!pdfContent__) {
        throw new Error("PDF content is empty");
      }
      console.log("PDF content:", html2pdf);
      // Optimize html2pdf settings for performance
      setTimeout(() => {
        html2pdf()
          .from(pdfContent__, "string")
          .set({
            margin: [0, 0, 0, 0],
            filename: "Quote.pdf",
            html2canvas: {
              scale: 1.9, // Reduce scale for better performance
              useCORS: true, // Enable CORS only if needed for external resources
              logging: false, // Disable logging for performance
            },
            jsPDF: {
              unit: "mm",
              format: "a4",
              orientation: "portrait",
            },
          })
          .save();
      }, 100);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  async sendQuoteEmail(draftOrderId) {
    const formatedDraftOrderId = draftOrderId.replace(
      "gid://shopify/DraftOrder/",
      ""
    );
    let pdfFile;
    const { buyingJourneyObject } = this.selectedTemplate;
    console.log("Sending Quote Email to the customer.");
    await this.createPDF()
      .then((pdfBlob) => {
        pdfFile = pdfBlob;
      })
      .catch((error) => {
        console.error("Failed to generate PDF:", error);
        return;
      });
    const currentUrl = window.location.origin + window.location.pathname;
    console.log(
      "You can edit your order by clicking this link:",
      `${currentUrl}?step=overview&orderId=${formatedDraftOrderId}`
    );

    const customer_email = buyingJourneyObject.gtAccessQoute.email;
    const cutomer_name = buyingJourneyObject.gtAccessQoute.firstName;
    const message = `Hi ${cutomer_name},
      <br>
      <br>
      Thank you for requesting a quote for our aluminium doors.
      <br>
      <br>
      We’ve prepared your personalised quote, which you’ll find attached as a PDF. This document includes all the details of your request, including pricing, specifications, and options.
      <br>
      <br>
      If you're ready to go ahead, please complete your order <a href="${buyingJourneyObject.invoiceUrl}">here</a>.
      <br>
      You can edit your order by clicking this link: ${currentUrl}?step=overview&orderId=${formatedDraftOrderId}
      <br>
      If you have any questions, need to make changes, or would like assistance moving forward with your order, we’re here to help. Please don’t hesitate to get in contact by replying to this email or calling us directly at 02476 694162.
      <br>
      <br>
      We’re excited to help bring your project to life and look forward to working with you!
      <br>
      <br>
      Warm regards,
      <br>
      Charlene
      <br>
      <img src="https://cdn.shopify.com/s/files/1/0930/7773/3711/files/BC.png" style="max-width:350px" alt="Signature" />
    `;

    // Create a FormData object to package the file and form data
    const formData = new FormData();
    formData.append("pdf", pdfFile, "quote.pdf"); // Ensure the file input's name matches with what the server expects
    formData.append("customer_email", customer_email);
    formData.append("message", message);

    try {
      // Use fetch API to send the form data to the server endpoint
      const response = await fetch(`${this.buyingJourneyApi}/send-quote`, {
        method: "POST",
        body: formData, // formData will set the appropriate Content-Type
      });

      // Check if the request was successful
      if (response.ok) {
        const result = await response.text(); // Or response.json() if server responds with JSON
        console.log("Email quote status:", result);
        return result;
      } else {
        // Handle non-2xx responses
        const errorText = await response.text();
        throw new Error(`Failed to send email: ${errorText}`);
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  }

  async createPDF() {
    try {
      // Optimize the content fetching process
      const pdfContent = await getDocumentFormatOfProduct();

      // Check if content exists and is valid
      if (!pdfContent) {
        throw new Error("PDF content is empty");
      }
      console.log("Generating PDF content");

      // Create a Promise to handle the asynchronous operation of html2pdf
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          html2pdf()
            .from(pdfContent, "string")
            .set({
              margin: [0, 0, 0, 0],
              filename: "Quote.pdf",
              html2canvas: {
                scale: 1.9,
                useCORS: true,
                logging: true,
              },
              jsPDF: {
                unit: "mm",
                format: "a4",
                orientation: "portrait",
              },
            })
            .output("blob") // Get the PDF as a Blob
            .then(resolve) // Resolve the Promise with the Blob
            .catch(reject); // Reject the Promise if an error occurs
        }, 100);
      });
    } catch (error) {
      console.error("Error generating PDF:", error);
      throw error; // Rethrow to notify of failure
    }
  }

  async verifyEmail() {
    let email = this.querySelector("#quote-email").value;
    this.verifyEmailWrapper.style.display = "none";
    try {
      const res = await fetch(`${this.buyingJourneyApi}/verify-email`, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (!res.ok) {
        console.log("Error while sending confirmation email.");
      } else {
        console.log("Confirmation email sent successfully");
      }
    } catch (err) {
      console.error(err);
    }
    this.verifyEmailPopup.style.display = "flex";
  }

  async verifyEmailStatus(email) {
    const resp = await fetch(
      `${this.buyingJourneyApi}/email-verify-status?email=${encodeURIComponent(
        email
      )}`
    );

    const { isVerified } = await resp.json();

    if (isVerified) {
      this.verifyEmailBtn.innerText = "Email is already verified";
      this.verifyEmailWrapper.dataset.verified = true;
      this.querySelector("#verifiy-email-label").classList.add("disabled");
      console.log("Email verification done successfully");
      this.emailVerified = true;
    } else {
      this.verifyEmailBtn.innerText =
        "Your email is not verified. Verify Email?";
      this.verifyEmailWrapper.dataset.verified = false;
      this.querySelector("#verifiy-email-label").classList.remove("disabled");
      console.log("Email verification still not done successfully");
      this.emailVerified = false;
    }
    this.verifyEmailWrapper.style.display = "flex";
  }

  async removeQuoteProduct(lineItemId, productId) {
    // Clear any existing timer
    if (this.removeQuoteProductDebounceTimer) {
      clearTimeout(this.removeQuoteProductDebounceTimer);
    }

    // Set a new timer to debounce the function call
    this.removeQuoteProductDebounceTimer = setTimeout(async () => {
      // Find the cart item element to remove from UI
      const cartItemElement = document
        .querySelector(`.removeQuoteProduct[data-item-id="${lineItemId}"]`)
        ?.closest(".bj-cart-bottom");

      // Show loading spinner
      const loadingWrapper = document.querySelector(
        ".adding-to-cart-loading-wraper"
      );
      if (loadingWrapper) {
        loadingWrapper.style.display = "block";
        loadingWrapper.querySelector(".loading__text").innerText =
          "Please wait while your product is being removed from cart...";
      }

      try {
        // Remove from UI immediately for better UX
        if (cartItemElement) {
          cartItemElement.style.opacity = "0.5";
          cartItemElement.style.transition = "opacity 0.3s ease";
        }

        // Remove the line item from the cart
        const cart = await this.removeProductFromCart(lineItemId);
        let isCartEmpty = cart.item_count === 0;

        // Remove from draft order (quote)
        const res = await fetch(
          `${this.buyingJourneyApi}/delete-draft-order-line-item`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              variantId: lineItemId,
              productId: productId,
              draftOrderId: this.draftOrderId,
            }),
          }
        );

        if (res.ok) {
          console.log("Product removed from draft order successfully");

          const totalPriceElement = document.querySelector(
            ".bj-cart-total-price .bj-cart-price"
          );
          const totalPrice = Number(totalPriceElement.dataset.totalPrice);
          const itemPrice = Number(
            cartItemElement?.querySelector("[data-price]")?.dataset.price
          );
          const totalPriceAfterRemoval = totalPrice - itemPrice;
          if (totalPriceElement) {
            totalPriceElement.textContent = Shopify.formatMoney(
              totalPriceAfterRemoval
            );
            totalPriceElement.setAttribute(
              "data-total-price",
              totalPriceAfterRemoval
            );
          }

          // Remove the item from the DOM
          if (cartItemElement) {
            cartItemElement.remove();
          }

          // Update cart display
          const cartWrapper = document.querySelector(".bj-cart-items-wrapper");

          if (isCartEmpty) {
            // Show empty cart message
            if (cartWrapper) {
              cartWrapper.innerHTML =
                '<div class="container container--xl"><div class="empty-cart-message"><p>Your cart is empty</p></div></div>';
            }

            // Hide loading spinner
            if (loadingWrapper) {
              loadingWrapper.style.display = "none";
            }

            // Redirect to products page after showing message
            setTimeout(() => {
              window.location.href = `${window.location.origin}/pages/choose-your-products`;
            }, 500);
          } else {
            // Update cart count and totals if needed
            const cartCountElements =
              document.querySelectorAll("[data-cart-count]");
            cartCountElements.forEach((el) => {
              el.textContent = cart.item_count;
            });

            // Hide loading spinner
            if (loadingWrapper) {
              loadingWrapper.style.display = "none";
            }

            // If on overview page, refresh the data without full reload
            if (window.location.search.includes("step=overview")) {
              // Optionally refresh cart display or other UI elements
              // For now, we've already updated the DOM
            }
          }
        } else {
          console.log("Error while removing product from draft order");
          // Revert UI changes on error
          if (cartItemElement) {
            cartItemElement.style.opacity = "1";
          }
          // Hide loading spinner on error
          if (loadingWrapper) {
            loadingWrapper.style.display = "none";
          }
          alert("Failed to remove product. Please try again.");
        }
      } catch (error) {
        console.error("Error removing quote product:", error);
        // Revert UI changes on error
        if (cartItemElement) {
          cartItemElement.style.opacity = "1";
        }
        // Hide loading spinner on error
        if (loadingWrapper) {
          loadingWrapper.style.display = "none";
        }
        alert(
          "An error occurred while removing the product. Please try again."
        );
      }
    }, 300); // 300ms debounce delay
  }
  async getPersonDetails() {
    const cartResponse = await fetch("/cart.js");
    const cartData = await cartResponse.json();

    // Try to find the first product in the cart with personal data in its properties
    let personalData = {};

    if (Array.isArray(cartData.items)) {
      for (const item of cartData.items) {
        if (item.properties) {
          // Try to extract personal data from properties
          personalData.firstName =
            item.properties["First name"] ||
            item.properties["firstName"] ||
            null;
          personalData.lastName =
            item.properties["Last name"] || item.properties["lastName"] || null;
          personalData.email =
            item.properties["Email"] || item.properties["email"] || null;
          personalData.phone =
            item.properties["Phone"] || item.properties["phone"] || null;
          personalData.postcode =
            item.properties["Postcode"] || item.properties["postcode"] || null;
        }
        // If we have found at least one piece of personal data, break
        if (
          personalData.firstName ||
          personalData.lastName ||
          personalData.email ||
          personalData.phone ||
          personalData.postcode
        ) {
          break;
        }
      }
    }

    this.personDetails = personalData;
  }
}

customElements.define("buying-journey", BuyingJourney);
